import { useCallback } from "react"

import useTracking from "./useTracking"

const useVideoTracking = () => {
  const { hasAnalytics, track, trackClick } = useTracking()

  /**
   * Tracks when a user plays a video (clicks on the play button).
   */
  const trackVideoView = (elementRef, trackingId) => {
    trackClick(elementRef, trackingId, {}, (props) => track("Hero Video Viewed", props))
  }

  /**
   * Returns a tracking function for tracking video view progress.
   */
  const trackVideoProgress = (trackingId, pageId) => {
    return useCallback(
      (percentViewed) => {
        const props = {
          ...(pageId && { pageId }),
          video_id: trackingId,
          percent_complete: percentViewed,
        }

        track(`Video Viewed ${percentViewed}%`, props)
      },
      [trackingId, pageId],
    )
  }

  return { trackVideoView, trackVideoProgress }
}

export default useVideoTracking
